// extracted by mini-css-extract-plugin
export default {"root":"vPLF6","img":"We6ew"};